import React from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Image from "next/image"

type Props = {
	className?:string
}
function BestPriceGuarantee({className = ""}:Props) {
	const {t} = useTranslation()
	const firstDesctiptionPart = t("best-monthly-price-description-label").slice(0, t("best-monthly-price-description-label").indexOf("months"))
	const secondDesctiptionPart = t("best-monthly-price-description-label").slice(t("best-monthly-price-description-label").indexOf("months"))
	return (
		<div style={{borderRadius: "4px", gap: "16px", padding: "16px", background: "#FFF6E7"}}
			className={`d-flex align-items-start justify-content-start flex-column col-12 ${className}`}>
			<div style={{gap: "16px"}}
				className="text-center mt-1 d-flex align-items-center justify-content-center ">
				<Image className="cursor-pointer"
					src="/assets/icons/checkmark-emoji.svg"
					alt="tools icon"
					width={24}
					height={24} />
				<Typography variant="bodySmBold"
					style={{fontSize: "14px", lineHeight: "20px"}}
					className="text-black">
					{t("best-monthly-price-label")}
				</Typography>
			</div>
			<Typography variant="bodyLg"
				style={{fontSize: "14px", lineHeight: "20px"}}
				semanticTag="p"
				className="my-0 p-0">{firstDesctiptionPart} <b>{` ${t("48-months")} `}</b>{ secondDesctiptionPart} </Typography>
		</div>
	)
}

export default BestPriceGuarantee
